import { Button, Spinner, Typography } from '@material-tailwind/react'
import { Modal } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { baseApi } from '../../../ConfigApi'
import { blobToBase64, isIterableArray, toFormatPrice, toStringPrice } from '../../../utils/utils'
import { errorToast } from '../../../components/toasts/toasts'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import CloseDrawerIcon from '../../../images/icons/CloseDrawerIcon'
import moment from 'moment'
import { useParams } from 'react-router-dom'


type PropsModal = {
    open: boolean,
    handleClose: any,
    modalValue: any,
}
const ModalViewBadgeItem = ({
    open,
    handleClose,
    modalValue,
}: PropsModal) => {

    const { t } = useTranslation()

    const { param_contract_id } = useParams()
    const service_id = useSelector((state: RootState) => state.contract.service_id)

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [frameData, setFrameData] = useState<any>(null);
    const [isError, setIsError] = useState<boolean>(false);

    const bgService = service_id === 1 ? 'bg-orange-50 text-orange-600' : service_id === 2 ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'
    const textService = service_id === 1 ? 'text-orange-600' : service_id === 2 ? 'text-blue-700' : 'text-gray-600'

    const selectedRowService = service_id === 1 ? 'bg-orange-100 ' : service_id === 2 ? 'bg-blue-100' : 'bg-gray-200'


    const handleFetch = (modalValue: any) => {
        // type from IVENTS_DATA
        switch (modalValue.type) {
            case 'plan': {
                setIsLoading(true)
                setIsError(false)
                fetchInvoice(modalValue.export)
                return
            }
            case 'final': {
                setIsLoading(true)
                setIsError(false)
                fetchInvoice(modalValue.export)
                return
            }
            case 'act': {
                setIsLoading(true)
                setIsError(false)
                fetchActs(modalValue.export)
                return
            }
            case 'payment': {
                setFrameData(modalValue)
                setIsLoading(false)
                setIsError(false)
                return
            }
            case 'change_condition': {
                setFrameData(modalValue)
                setIsLoading(false)
                return
            }
            default:
                break;
        }
    }

    const fetchActs = (formSend: any) => {
        axios.post(`${baseApi}/api/acts/export-file`, {
            contract_id: Number(param_contract_id),
            ...formSend
        }, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    setIsError(true)
                }
                else {
                    setIsError(false)
                    blobToBase64(response.data).then((res: any) => {
                        setFrameData(res)
                    });
                }
            })
            .catch(error => {
                console.error(error);
                setIsError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }
    const fetchInvoice = (formSend: any) => {
        axios.post(`${baseApi}/api/invoice/export-file`, formSend, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    setIsError(true)
                }
                else {
                    setIsError(false)
                    blobToBase64(response.data).then((res: any) => {
                        setFrameData(res)
                    });
                }
            })
            .catch(error => {
                console.error(error);
                setIsError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        if (open && modalValue) handleFetch(modalValue)
        return () => {
            setFrameData(null)
            setIsError(false)
            setIsLoading(true)
        };
    }, [open, modalValue]);

    const RenderDataByType = () => {
        switch (modalValue.type) {
            case 'plan': {
                return (
                    <div className='w-[calc(100vw-16px)] tab:w-[700px] lap:w-[1200px] my-[16px] animate-appear' style={{ animationDuration: '.4s' }}>
                        <div className='flex justify-end items-center mb-[16px]'>
                            <div onClick={handleClose} className="bg-white rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div>
                        </div>
                        <iframe src={frameData} className='h-[90vh] w-full' />
                    </div>
                )
            }
            case 'final': {
                return (
                    <div className='w-[calc(100vw-16px)] tab:w-[700px] lap:w-[1200px] my-[16px] animate-appear' style={{ animationDuration: '.4s' }}>
                        <div className='flex justify-end items-center mb-[16px]'>
                            <div onClick={handleClose} className="bg-white rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div>
                        </div>
                        <iframe src={frameData} className='h-[90vh] w-full' />
                    </div>
                )
            }
            case 'act': {
                return (
                    <div className='w-[calc(100vw-16px)] tab:w-[700px] lap:w-[1200px] my-[16px] animate-appear' style={{ animationDuration: '.4s' }}>
                        <div className='flex justify-end items-center mb-[16px]'>
                            <div onClick={handleClose} className="bg-white rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div>
                        </div>
                        <iframe src={frameData} className='h-[90vh] w-full' />
                    </div>
                )
            }
            case 'payment': {
                return (
                    <div className='overflow-auto max-h-[80vh] w-[calc(100vw-16px)] tab:w-[800px] p-[16px] max-h-[90vh] bg-white rounded-[12px] my-[16px] lap:m-[24px] w-full '>
                        <div className='flex justify-between items-center mb-[16px]'>
                            <p className={` 
                                ${bgService} px-[16px] py-[8px] rounded-full  
                            `}>
                                {/* break-all */}
                                {t('contract_page.payment_view')}
                            </p>
                            <div onClick={handleClose} className="rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div>
                        </div>
                        <div className=' bg-gray-50 border-2 border-gray-100 p-[24px] tab:p-[32px] rounded-[16px]'>
                            <div className='grid tab:grid-cols-2 lap:grid-cols-3 gap-[16px] tab:gap-[24px] lap:gap-[96px]'>

                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_period')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {modalValue.info.month}-{modalValue.info.year}
                                    </p>
                                </div>
                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_date')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {modalValue.info.date}
                                    </p>
                                </div>
                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_balance')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {t(`balance_${modalValue.info.balance_id}`)}
                                    </p>
                                </div>
                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_type_invoice')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {
                                            isIterableArray(modalValue?.type_invoice) ?
                                                modalValue?.type_invoice.map((item: string, key: number) => (
                                                    <span key={key} className='flex mb-[6px]'>{t(`contract_page.type_invoice_${item}`)}</span>
                                                ))
                                                :
                                                ' - '
                                        }
                                    </p>
                                </div>
                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_target_number')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {
                                            isIterableArray(modalValue?.target_number) ?
                                                modalValue?.target_number.map((item: string, key: number) => (
                                                    <span key={key} className='flex mb-[6px]'>{item}</span>
                                                ))
                                                :
                                                ' - '
                                        }
                                    </p>
                                </div>
                                <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                    <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                        {t('contract_page.payment_view_type_sum')}
                                    </p>
                                    <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                        {toFormatPrice(modalValue?.info.sum)}
                                    </p>
                                </div>
                            </div>
                            <hr className='border-1 border-gray-100 my-[24px]' />

                            <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                    {t('contract_page.payment_view_order_pay')}
                                </p>
                                <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                    {modalValue?.info.order_pay ? modalValue?.info.order_pay : " - "}
                                </p>
                            </div>
                            <hr className='border-1 border-gray-100 my-[24px]' />

                            <div className='flex flex-col gap-[4px] tab:gap-[8px] '>
                                <p className=' text-[14px] lap:text-[16px] text-gray-700'>
                                    {t('contract_page.payment_view_pay_purpose')}
                                </p>
                                <p className=' text-[14px] lap:text-[18px] font-medium text-gray-800'>
                                    {modalValue?.info.pay_purpose ? modalValue?.info.pay_purpose : " - "}
                                </p>
                            </div>
                        </div>
                    </div>
                )
            }
            case 'change_condition': {
                return (
                    <div className='overflow-auto max-h-[80vh]  w-[calc(100vw-16px)] tab:w-[800px] p-[16px] max-h-[80vh] bg-white rounded-[12px] my-[24px] overflow-auto max-w-[calc(100vw-16px)] tab:max-w-auto tab:min-w-[700px]'>
                        <div className='flex justify-between items-center mb-[16px]'>
                            <p className={` 
                                ${bgService} px-[16px] py-[8px] rounded-full  
                            `}>
                                {/* break-all */}
                                {t('contract_page.calendar_target_change_condition')}
                            </p>
                            <div onClick={handleClose} className="rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div>
                        </div>
                        <div className='overflow-auto'>
                            <div className='flex items-end justify-between pb-[8px] px-[10px] mob:px-[16px] lap:px-[24px] min-w-[700px]'>
                                <p className={`w-[20%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500`}>
                                    {t(`contract_page.method_date_title`)}
                                </p>
                                <p className='w-[30%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500'>
                                    {t(`contract_page.method_type_title`)}
                                </p>
                                <p className={`w-[30%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500`}>
                                    {t(`contract_page.method_val_title`)}
                                </p>
                                <p className='w-[20%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500'>

                                    {t(`contract_page.method_allocation_title`)}
                                </p>
                            </div>
                            {/* p-[8px_4px] mob:p-[16px_8px] lap:p-[24px_12px] */}
                            <div className='bg-gray-50 border-2 border-gray-200  rounded-[16px] grow min-w-[700px] max-h-[75vh]'>
                                {
                                    isIterableArray(modalValue?.info) ?
                                        modalValue.info.map((item: any, key: number) => (
                                            <div key={key} className={`px-[6px] mob:px-[12px] lap:px-[14px] flex items-center justify-between py-[10px] rounded-[8px]   ${item.selected ? selectedRowService : ' border-b border-gray-100 last:border-0 '}`}>
                                                <p className={`w-[20%] font-bold text-[12px] tab:text-[14px] lap:text-[16px] ${textService}`}>
                                                    {moment(item.date_from).format('DD.MM.YYYY')}
                                                </p>
                                                <p className='w-[30%] font-medium text-[12px] mob:text-[14px] lap:text-[16px] text-gray-800'>
                                                    {
                                                        item.method_type === 3 ?
                                                            <>{t(`contract_page.method_type_${item.method_type}`)}</>
                                                            :
                                                            item?.delta_value ?
                                                                `${item.delta_type === 2 ? t(`contract_page.delta_type_${item.delta_type}`) : t(`contract_page.delta_type_${item.delta_type}`)}`
                                                                :
                                                                ''
                                                    }
                                                </p>
                                                <p className={`w-[30%] font-bold text-[14px] lap:text-[16px] ${textService}`}>
                                                    {
                                                        item.method_type === 3 ?
                                                            <>{toStringPrice(item?.fix_price)}{t('contract_page.delta_unit1')}</>
                                                            :
                                                            item?.delta_value ?
                                                                `   
                                                                                       ${item.delta_type === 2 ? '-' : ''} 
                                                                                       ${toStringPrice(item?.delta_value)} 
                                                                                       ${item?.delta_unit === 1 ?
                                                                    t("contract_page.delta_unit1")
                                                                    :
                                                                    t("contract_page.delta_unit2")
                                                                }`
                                                                :
                                                                ''
                                                    }
                                                </p>
                                                <p className='w-[20%] font-medium text-[14px] lap:text-[16px] text-gray-800'>
                                                    {item.allocation ? t('contract_page.allocation_1') : t('contract_page.allocation_0')}
                                                </p>
                                            </div>
                                        ))
                                        :
                                        ' - '
                                }
                            </div>
                        </div>
                    </div>
                )
            }
            default: {
                return (
                    <div>
                        unvalid data
                    </div>
                )
            }
        }
    }
    return (
        createPortal(
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='flex items-center justify-center !z-[9999] '
            >
                <div
                    className={`
                    
                    flex justify-center items-center transition-all rounded-[12px]
                `}
                >
                    {
                        isLoading ?
                            <div className='flex justify-center items-center transition-all rounded-[12px]'>
                                <Spinner />
                            </div>
                            :
                            frameData ?
                                <RenderDataByType />
                                :
                                isError ?
                                    <div className='bg-white rounded-[12px] p-[24px_32px] mx-[32px]'>
                                        <div className='flex justify-end items-center mb-[16px]'>
                                            <div onClick={handleClose} className="rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                                <CloseDrawerIcon />
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center gap-[24px] ">
                                            <Typography variant='lead' className='text-[16px] lap:text-[20px] font-bold text-center'>
                                                {t('error_on_load_try_again')}
                                            </Typography>
                                            <Button color='white' onClick={() => handleFetch(modalValue)} className='mx-auto'>
                                                {t('reload')}
                                            </Button>
                                        </div>
                                    </div>
                                    :
                                    ''
                    }
                </div>
            </Modal>,
            document.getElementById('root')!
        )
    )
}

export default ModalViewBadgeItem
